import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/users/new/")({
  component: lazyImportRouteComponent(
    () => import("./-components/NewUserPage"),
    "NewUserPage"
  ),
})
